import { withInstall } from '@jdesign-vue/utils'

import Empty from './src/empty.vue'

export const JdEmpty = withInstall(Empty)
export default JdEmpty

export * from './src/empty'
export type { EmptyInstance } from './src/instance'
